import { BASE_URL } from '../constants';

export const getBaseUrl = () => {
  const debug = !!localStorage.getItem('test_al');
  let baseURL = BASE_URL;

  try {
    const devDomain = import.meta.env.VITE_APP_API_URL;
    baseURL = devDomain ? `${devDomain}/api` : baseURL;
  } catch (err) {
    debug && console.error(err);
  }

  // for test env purposes 'https://api-test.playdeck.io/api';
  return baseURL;
  // return 'https://api-test.playdeck.io/api';
};
